import React from "react";
import CustomInput from "../../../../../../Component/DigitalMarketing/CustomInput";
import CustomCheckbox from "../../../../../../Component/DigitalMarketing/Forms/CustomCheckbox";
import { useGetNewMedicineListQuery } from "../../../../../../Service/MedicineMaster";

const Medicines = (props: any) => {
  const { formData, setFormData, submit } = props;

  const { data: MedicineMasterData } = useGetNewMedicineListQuery();

  // Map API data to dropdown options
  const medicineOptions =
    MedicineMasterData?.data?.map((m: any) => ({
      value: m.id,
      label: m.medicineName,
    })) || [];

  const intakeOptions = [
    { value: "before food", label: "Before Food" },
    { value: "after food", label: "After Food" },
  ];

  // Handle checkbox changes (medicineIntake)
  const handleCheckboxChange = (selected: string[], index: number) => {
    setFormData((prevData: any) => {
      const updatedFormData = [...prevData.prescriptionMaster];
      updatedFormData[index] = {
        ...updatedFormData[index],
        medicineIntake: selected,
      };
      return { ...prevData, prescriptionMaster: updatedFormData };
    });
  };

  // Handle input/select changes
  const handleChange = (e: any, index: number) => {
    const { name, value } = e.target;

    setFormData((prevData: any) => {
      const updatedMedicines = prevData.prescriptionMaster.map((medicine: any, i: number) => {
        if (i === index) {
          if (name === "medicineId") {
            // Lookup medicineName from ID
            const selectedMedicine = MedicineMasterData?.data?.find((m: any) => m.id == value);
            return {
              ...medicine,
              medicineId: value,
              medicineName: selectedMedicine?.medicineName || "",
            };
          }
          return { ...medicine, [name]: value };
        }
        return medicine;
      });

      return { ...prevData, prescriptionMaster: updatedMedicines };
    });
  };

  // Add new medicine row
  const handleAddMedicine = () => {
    setFormData((prevData: any) => ({
      ...prevData,
      prescriptionMaster: [
        ...(prevData.prescriptionMaster || []),
        {
          medicineId: "",      // store ID
          medicineName: "",    // store actual name
          medicineDosage: "",
          medicineIntake: [],
          inTake: "",
          medicineDays: "",
        },
      ],
    }));
  };

  // Remove medicine row
  const handleRemoveMedicine = (index: number) => {
    setFormData((prevData: any) => ({
      ...prevData,
      prescriptionMaster: prevData.prescriptionMaster.filter((_: any, i: number) => i !== index),
    }));
  };

  return (
    <div className="row">
      <span className="prescription-headline col-12 rounded">Medicines</span>

      {formData?.prescriptionMaster?.length > 0 ? (
        formData.prescriptionMaster.map((medicine: any, index: number) => (
          <div key={index} className="row align-items-center">
            {/* Medicine Dropdown */}
            <div className="col-6">
              <CustomInput
                label="Medicine"
                type="select"
                option={medicineOptions}
                labelKey="label"
                valueKey="value"
                submit={submit}
                name="medicineId"
                value={medicine.medicineId}
                onChange={(e: any) => handleChange(e, index)}
              />
            </div>

            {/* Strength */}
            <div className="col-5">
              <CustomInput
                type="text"
                label="Strength (mg)"
                submit={submit}
                name="medicineDosage"
                value={medicine.medicineDosage}
                onChange={(e: any) => handleChange(e, index)}
              />
            </div>

            {/* Frequency */}
            <div className="col-10">
              <label className="form-label">Frequency</label>
              <div className="d-flex align-items-center gap-2">
                <CustomCheckbox
                  options={[
                    { label: "Morning" },
                    { label: "Afternoon" },
                    { label: "Night" },
                  ]}
                  selectedLabels={medicine.medicineIntake || []}
                  onLabelSelect={(selected: string[]) => handleCheckboxChange(selected, index)}
                />
              </div>
            </div>

            {/* Intake */}
            <div className="col-4">
              <CustomInput
                label="In Take"
                type="select"
                option={intakeOptions}
                labelKey="label"
                valueKey="value"
                submit={submit}
                name="inTake"
                value={medicine.inTake}
                onChange={(e: any) => handleChange(e, index)}
              />
            </div>

            {/* Days */}
            <div className="col-5">
              <CustomInput
                type="text"
                label="Days"
                submit={submit}
                name="medicineDays"
                value={medicine.medicineDays}
                onChange={(e: any) => handleChange(e, index)}
              />
            </div>

            {/* Delete button */}
            <div className="col-3 mt-3">
              <span
                className="material-symbols-outlined cursor-pointer"
                style={{ color: "#F72847" }}
                onClick={() => handleRemoveMedicine(index)}
              >
                delete
              </span>
            </div>
            <hr />
          </div>
        ))
      ) : (
        <p className="mt-3">No medicines added yet. Click Add more</p>
      )}

      {/* Add More */}
      <div>
        <span onClick={handleAddMedicine} style={{ color: "#6842D9" }}>
          <span className="d-flex gap-1 align-items-center cursor-pointer">
            <span className="material-symbols-outlined">add</span>
            <span className="fw-bold fw-700 f-14">
              <u>Add more</u>
            </span>
          </span>
        </span>
      </div>
    </div>
  );
};

export default Medicines;
